import api from 'api';
import axios from 'axios';
import PropTypes from 'prop-types';
import { useContext, useEffect, useState } from 'react';

import { ChartContext } from 'state/contexts/chart';

import { Loading } from 'components/elements';
import { debug } from 'utils/helpers';

import { ChartBox, ChartSection } from 'components/general-styles';
import { ActionTypes } from 'state/reducers/chart';
import Charts from './chart';

const HeartRateChart = ({ patientId, patientUuid, visible }) => {
  const { chartState, chartDispatch } = useContext(ChartContext);

  const [loading, setLoading] = useState(true);
  const [chart, setChart] = useState();

  useEffect(() => {
    setLoading(true);

    const source = axios.CancelToken.source();

    const getChartData = async () => {
      if (!(chartState.patientId === patientId && chartState.data.healthkits.values)) {
        if (chartState.patientId !== patientId) {
          chartDispatch({ type: ActionTypes.CLEAR });
        }
        try {
          const { data } = await api().get(`/healthkit/${patientUuid}/AUTH_TOKEN`, {
            cancelToken: source.token,
          });

          chartDispatch({
            type: ActionTypes.SET,
            payload: {
              patientId,
              data,
            },
          });

          setChart(data);
          setLoading(false);
        } catch (err) {
          if (!axios.isCancel(err)) {
            debug(err);
            setLoading(false);
          }
        }
      } else {
        setChart(chartState.data);
        setLoading(false);
      }
    };

    getChartData();

    return () => {
      source.cancel();
    };
  }, [patientId]);

  if (!visible) {
    return null;
  }

  if (loading) return <Loading />;

  return (
    <>
      {chart && (
        <ChartSection>
          <ChartBox>{chart.healthkits && <Charts />}</ChartBox>
        </ChartSection>
      )}
    </>
  );
};

HeartRateChart.propTypes = {
  patientId: PropTypes.number.isRequired,
  patientUuid: PropTypes.string.isRequired,
};

HeartRateChart.defaultProps = {};

export default HeartRateChart;
